export function resolveLeaderboardAnonymousToggle({
  canRemainAnonymous,
  preference,
}: {
  canRemainAnonymous: boolean;
  preference: boolean;
}): { checked: boolean; requiresUpgrade: boolean } {
  if (!canRemainAnonymous) {
    return { checked: false, requiresUpgrade: true };
  }
  return { checked: preference, requiresUpgrade: false };
}
